export default class OrderQueueTimer {
  constructor({ orderEl, timeout, wait, statusPath, immediate = false }) {
    this._el = orderEl;
    this._timeout = timeout;
    this._wait = wait;
    this._statusPath = statusPath;
    this._immediate = immediate;
    this._retries = 0;
    if (
      orderEl == null ||
      orderEl === "" ||
      timeout == null ||
      statusPath == null ||
      statusPath === ""
    ) {
      throw new TypeError(
        `Some arguments are empty. orderEl: ${orderEl}, timeout: ${timeout}, statusPath: ${statusPath}`
      );
    }
  }

  run() {
    // If socket error
    if (this._el.getAttribute("data-message-type") === "error") {
      return;
    }
    this._replaceOrderForm()._initializeTimers();
  }

  template() {
    return `
      <div class="flex flex-col items-center w-full text-sm min-h-[4rem] justify-center">
        <div class="js-progress-container" style="max-width: 220px;">
          <progress value="1" max="1"></progress>
        </div>
        ${window.TC_LABELS?.ORDER_PROCESSING}
      </div>
    `;
  }

  _replaceOrderForm() {
    this._el.innerHTML = this.template();
    return this;
  }

  _initializeTimers() {
    if (this._immediate === true) {
      this._timerHandler();
      this._immediate = false;
      return this;
    }
    if (this._redirectTimer != null) {
      window.clearTimeout(this._redirectTimer);
    }
    this._redirectTimer = window.setTimeout(
      this._timerHandler.bind(this),
      this._timeout
    );
    if (this._wait === 0) return this;
    if (this._waitTimer == null) {
      this._waitTimer = new window.VirtualProgressTimer(this._wait);
      this._waitTimer.map((_, { elapsedPercent }) => {
        $(this._el).find(".js-progress-container").html(`
        <progress value='${elapsedPercent}'
        max='${1}' / >
        `);
      });
    } else {
      this._waitTimer.postpone(this._wait);
    }

    return this;
  }

  _checkStatusAction(succ, err) {
    $.ajax({
      url: this._statusPath,
      cache: false,
      dataType: "json",
      success: succ,
      error: err,
    });
  }

  _timerHandler() {
    this._checkStatusAction(
      (res) => {
        this._retries = 0;
        if (res.url && res.url !== "") {
          if (this._waitTimer != null) {
            this._waitTimer.stop();
          }
          this._waitTimer = undefined;
          this._redirectAction(res.url);
        } else if (res.action === "reload") {
          window.location.reload();
        } else {
          this._wait = res.wait;
          this._timeout = res.timeout || 5000;
          this._initializeTimers();
        }
      },
      (err) => {
        this._retries++;
        console.log(`Error: ${err}`);
        if (this._retries < 10) {
          this._wait = 0;
          this._timeout = 5000;
          this._initializeTimers();
        } else {
          window.location.reload();
        }
      }
    );
  }

  _redirectAction(url) {
    window.location.href = url;
  }
}
